import React, {useMemo} from 'react'
import styles from './UIGameSpectators.module.scss'
import {Avatar} from '../../common/Avatar/Avatar'
import {t, Tooltip} from '@colonist/ui'
// eslint-disable-next-line no-restricted-imports
import {getLobbyImagePath} from '../../../../../code/client/shared/scripts/ui_utils/Utils'
import {LobbyImage} from '@colonist/types'
import {useUIGameSpectatorsContext} from './UIGameSpectatorsContext'
import {PlayerColor} from '@colonist/game-states'

export interface UIGameSpectatorsProps {
    maxAvatarsVisible?: number
}

const MAX_TOOLTIP_NAMES = 10

export const UIGameSpectators = ({maxAvatarsVisible = 3}: UIGameSpectatorsProps) => {
    const {spectators} = useUIGameSpectatorsContext()
    const visibleSpectators = spectators.slice(0, maxAvatarsVisible)
    const extraCount = spectators.length - maxAvatarsVisible
    const hiddenSpectators = spectators.slice(maxAvatarsVisible)
    const tooltipUsernamesText = useMemo(() => hiddenSpectators.slice(0, MAX_TOOLTIP_NAMES).map((s) => s.username).join(', '), [hiddenSpectators])

    if(spectators.length === 0) return null

    const tooltipOverflowCount = hiddenSpectators.length - MAX_TOOLTIP_NAMES
    const isSpectatorListOverflowing = hiddenSpectators.length > MAX_TOOLTIP_NAMES
    const tooltipOverflowText = isSpectatorListOverflowing ? t('strings:game.tooltips.andOthers', {count: tooltipOverflowCount}) : ''

    return (
        <div className={styles.spectatorsContainer}>
            <div className={styles.avatarsContainer}>
                {visibleSpectators.map((spectator, idx) => (
                    <Tooltip key={spectator.username + idx} title={spectator.username}>
                        <Avatar
                            color={PlayerColor.White}
                            className={styles.avatar}
                            image={spectator.avatar}
                            profilePictureUrl={spectator.profilePictureUrl} />
                    </Tooltip>
                ))}
                {extraCount > 0 && (
                    <Tooltip
                        menuClassName={styles.spectatorsTooltipMenu}
                        centerText
                        content={<>{tooltipUsernamesText}{tooltipOverflowText}</>}
                    >
                        <div className={styles.extraCount}>+{extraCount}</div>
                    </Tooltip>
                )}
            </div>
            <div className={styles.eyeIcon}>
                <img src={getLobbyImagePath(LobbyImage.Eye)} />
            </div>
        </div>
    )
}
